@app.service 'ShopifyService', ($state, localStorageService, $resource, $q, authenticationService) ->

  @setHeaderParams = (currentUser) =>
    if currentUser
      userToken = localStorageService.get('user.token')
      @headerParams = { 'Authorization': 'Bearer ' + userToken, "x-csrf-token":undefined }
    else
      @headerParams = null

    @resource = $resource "#{csConfig.chefstepsEndpoint}/api/v0/shopping/products/:id", { id: '@id' },
      'index':
        method: 'GET'
        isArray: true
        headers: @headerParams
      'show':
        method: 'GET'
        isArray: false
        headers: @headerParams

  @loadData = (currentUser) =>
    @setHeaderParams(currentUser)
    deferred = $q.defer()

    if @products
      deferred.resolve @products
    else
      loadDataSuccess = (data) =>
        @products = data
        deferred.resolve @products
      loadDataError = (error) ->
        Rollbar.error("ShopifyService - error while calling loadData at url: #{$state.current.url}, error: #{JSON.stringify(error)}")
        if error.status == 403
          $state.go 'logout'
        deferred.reject error

      @resource.index(loadDataSuccess, loadDataError)

    deferred.promise

  @productForSku = (sku) =>
    if @products && @products.length > 0
      _.find @products, (product) -> product.sku == sku
    else
      Rollbar.error("ShopifyButton - @products not set for button at url: #{$state.current.url}, products: #{@products}, sku: #{sku}")

  this
